export interface TimeEntry {
  selectedContracts: Array<{ label: string; id: string }>;
  date: string;
  workFrom: string;
  workTo: string;
  mealsFrom: string;
  mealsTo: string;
  travelToLocationFrom: string;
  travelToLocationTo: string;
  travelFromLocationFrom: string;
  travelFromLocationTo: string;
  fittingsMakeupTestFrom: string;
  fittingsMakeupTestTo: string;
}
